import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { getError, getToken, removeError, setError } from "./auth";
import { getUrlParams, isNGqp } from "@/utils/index.ts";
import { createUuid } from "./uuid";
import dayjs from "dayjs";
// baseURL
const BASE_URL = "";
enum RequestEnums {
	TIMEOUT = 20000,
	OVERDUE = 600, // 登录失效
	FAIL = 999, // 请求失败
	SUCCESS = 200, // 请求成功
}
const instance = axios.create({
	baseURL: BASE_URL,
	timeout: RequestEnums.TIMEOUT,
});
instance.interceptors.request.use(
	(config) => {
		// 请求头 token配置
		const token = isNGqp() ? getToken("token") : getToken() || getUrlParams("cert");
		const traceId = createUuid();
		if (token) {
			config.headers = {
				...config.headers,
				"X-Token": token,
				"X-User-ID": getUrlParams("userid"),
				"X-Trace-Id": traceId,
				Authorization: token,
			} as any;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	(response) => {
		const res = response.data as any;
		// 正确状态
		console.log(response);
		if (res.code === 0) {
			return res || true;
		}
		if (res.code && res.code !== 0) {
			console.log("1");
		}
		// 登录失效
		if (res.code === -1) {
			console.log("1");
			getErrorList(response);
		}
		// 异常
		// ElMessage.error(res.message);
		return Promise.reject(res?.msg || res?.message || "Network Error");
	},
	(error) => {
		console.log("err" + error); // for debug
		// 没权限时，不再重复提示
		if (error === "没有操作权限") return;
		// ElMessage.error("网络超时，稍后再试吧");
		return Promise.reject(error);
	}
);
const getErrorList = (response: any) => {
	let updatedErrors = [
		{
			url: `${response.config.url}`,
			code: response.status,
			payload: `参数：${response.config.data}错误提示：${JSON.stringify(response.data)}`,
			ip: "1.1.1.1",
			platform: 3, // Platform_IOS: 1; Platform_ANDROID: 2; Platform_H5: 4;
			created_at: dayjs().toISOString(),
		},
	];
	const list = getError();
	if (list.length > 0) {
		updatedErrors = [...updatedErrors, ...list]; // 合并错误列表
	}
	setError(updatedErrors);
	// 使用 async 函数封装 setTimeout 中的异步请求
	setTimeout(async () => {
		try {
			const rsp = await fetch(
				`${import.meta.env.DEV ? import.meta.env.VITE_API_BASE_URL : `https://${window.location.host}`}/v1/api/error-report/upload`,
				{
					method: "POST",
					body: JSON.stringify({ data: updatedErrors }), // 将 body 转为 JSON 字符串
					headers: new Headers({
						"X-Token": isNGqp() ? getToken("token") : getToken(),
						"Content-Type": "application/json", // 添加 Content-Type
					}),
				}
			);
			const responseData = await rsp.json(); // 解析响应数据
			if (responseData.code === 0) {
				removeError(); // 成功后清除错误
			}
		} catch (error) {
			console.error("Error uploading data:", error); // 捕获请求错误
		}
	}, 10000); // 延时 10 秒后上传
};
const request = <T = any>(config: AxiosRequestConfig | string, options?: AxiosRequestConfig): Promise<T> => {
	if (typeof config === "string") {
		if (!options) {
			return instance.request<T, T>({
				url: config,
			});
			// throw new Error('请配置正确的请求参数');
		} else {
			return instance.request<T, T>({
				url: config,
				...options,
			});
		}
	} else {
		return instance.request<T, T>(config);
	}
};
export function get<T = any>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> {
	return request({ ...config, method: "GET" }, options);
}

export function post<T = any>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> {
	return request({ ...config, method: "POST" }, options);
}

export default request;
export type { AxiosInstance, AxiosResponse };
